import { call } from 'redux-saga/effects';
import { mapSDKLabelsToDeviceIds } from 'utils/sdk/mapSDKLabelsToDeviceIds';

export function* applyMediaDevicesSaga(devicesConfig: Partial<Record<MediaDeviceKind, string>>) {
  yield call(mapSDKLabelsToDeviceIds, devicesConfig);
}
